import axios from 'axios';

const api = '/api/document-info';

export const getDocument = () => {
  return axios.get(`${api}?cacheBuster=${new Date().getTime()}`);
};

export const saveDocumentInfo = data => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, data);
};
